export const env = {
  apiBaseUrl: process.env.REACT_APP_API_URL || '/api',
  mapTileUrl:
    process.env.REACT_APP_MAP_TILE_URL ||
    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  leafletIconBase:
    process.env.REACT_APP_LEAFLET_ICON_BASE_URL ||
    'https://unpkg.com/leaflet@1.9.4/dist/images',
  defaultMapCenter: {
    lat: Number(process.env.REACT_APP_DEFAULT_MAP_LAT || 6.9271),
    lng: Number(process.env.REACT_APP_DEFAULT_MAP_LNG || 79.8612),
  },
};
